import React, { PureComponent } from 'react';
import PropTypes from 'prop-types';
import { injectIntl } from 'react-intl';
import { TableColumn, Button } from 'react-md';
import cn from 'classnames';


import { invokeBackendApi } from '../../libs/awsLib';
import LoaderButton from '../LoaderButton';

export default injectIntl(class PsyActionsColumn extends PureComponent {
  static propTypes = {
    segment: PropTypes.object.isRequired,
    isLoading: PropTypes.bool,
    isAccepted: PropTypes.bool,
    isRejected: PropTypes.bool,
  }

  state = {
    isLoading: false,
    accepted: false,
    rejected: false,
  };

  handleClickReportError = (segment, errorType, errorReason) => {
    // console.log('segmentClicked : ', segment);
    const path = `/segments/${segment.segmentId}/report`;
    const body = { errorType, errorReason };
    this.setState({ reported: true });
    return invokeBackendApi({ path, method: 'POST', body });
  }

  handleReject = (e, segment) => {
    e.stopPropagation();
    e.nativeEvent.stopImmediatePropagation();
    this.setState({ isLoading: true });
    const path = `/segments/${segment.segmentId}/reject`;
    invokeBackendApi({ path, method: 'POST' })
      .then(() => {
        this.setState({ isLoading: false, rejected: true });
      });
  }

  handleAccept = (e, segment) => {
    e.stopPropagation();
    e.nativeEvent.stopImmediatePropagation();
    this.setState({ isLoading: true });
    const path = `/segments/${segment.segmentId}/accept`;
    invokeBackendApi({ path, method: 'POST' })
      .then(() => {
        this.setState({ isLoading: false, accepted: true });
      });
  }

  render() {
    const {
      segment, isLoading: isLoadingProps, isAccepted, isRejected,
    } = this.props;
    const { accepted, rejected, isLoading } = this.state;

    return (
      <TableColumn className="md-text-center">
        {(isLoading || isLoadingProps) && <LoaderButton icon className="md-btn--icon-xmini" isLoading={isLoading || isLoadingProps} />}
        {!isLoading && !accepted && !isLoadingProps && !isAccepted &&
          <Button
            className={cn('md-btn--icon-xmini', 'icon-reject', { disabled: rejected })}
            icon
            onClick={e => this.handleReject(e, segment)}
            disabled={rejected}
          >
            close
          </Button>
        }
        {!isLoading && !rejected && !isLoadingProps && !isRejected &&
          <Button
            className={cn('md-btn--icon-xmini', { disabled: accepted })}
            icon
            onClick={e => this.handleAccept(e, segment)}
            disabled={accepted}
            swapTheming
            primary
          >
            done
          </Button>
        }
      </TableColumn>


    );
  }
});



// WEBPACK FOOTER //
// ./src/components/Contested/PsyActions.js